<template>
	<div v-if="image" class="landing-background-image" :style="backgroundImageStyle"></div>
</template>

<script>
export default {
	name: 'LandingBackgroundImage',

	props: {
		image: {
			type: [String, null],
			default: null,
		},
	},

	computed: {
		backgroundImageStyle() {
			if (!this.image) {
				return {}
			}

			return {
				backgroundImage: `url(${this.image})`,
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-background-image {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	pointer-events: none;
	z-index: -1;
}
</style>
